export const serializeFlow = ({ nodes, edges, triggers, name, is_active }) => {
    const startNode = nodes.find(n => n.type === 'start');

    // Store generated nodes to add them to the final list
    const generatedNodes = [];
    const generatedEdges = [];
    // Map to track edge redirections: originalSourceId -> newSourceId
    const sourceRedirections = {};

    const baseSerializedNodes = nodes.map(node => {
        let config = node.data.config || {};
        let finalNodeId = node.id;

        // Transformation rules based on node type
        // Transformation rules based on node type
        if (node.type === 'send_form') {
            const {
                flow_id, flow_token, cta_text,
                wait_for_response, wait_save_as, wait_timeout_ms,
                ...rest
            } = config;

            config = {
                ...rest,
                form: { flow_id, flow_token, cta_text }
            };

            // NOTE: Auto-injection of wait nodes removed as per request.
            // User must explicitly add wait nodes in the builder if needed.

        } else if (node.type === 'send_payment_link') {
            const {
                body_text, catalog_id, payment_gateway,
                currency, tax_rate, total_amount, product_items,
                wait_for_payment, wait_save_as, wait_timeout_ms,
                ...rest
            } = config;

            if (body_text || catalog_id || payment_gateway) {
                config = {
                    ...rest,
                    vars: {
                        payment_config: {
                            body_text,
                            catalog_id,
                            payment_gateway: payment_gateway === 'razorpay'
                                ? { type: 'razorpay', configuration_name: 'mathmen' } // Defaulting config name as per example
                                : { type: payment_gateway }
                        },
                        ...((currency || total_amount || product_items) ? {
                            payment_info: {
                                currency: currency || "INR",
                                tax_rate: Number(tax_rate || 0),
                                total_amount: total_amount,
                                product_items: (product_items || []).map(item => ({
                                    quantity: Number(item.quantity || 1),
                                    item_price: item.item_price,
                                    product_name: item.product_name,
                                    product_retailer_id: item.product_retailer_id
                                }))
                            }
                        } : {})
                    },
                    input_payload_var: 'payment_config',
                    ...((currency || total_amount || product_items) ? {
                        state_input_payload_var: "payment_info"
                    } : {})
                };
            }

            // NOTE: Auto-injection of wait/process nodes removed.

        } else if (node.type === 'create_reservation') {
            const {
                reservation_date, reservation_time, reservation_name, reservation_number,
                reservation_country_code, reservation_pax, reservation_business_id,
                reservation_remark, output_payload_var, ...rest
            } = config;

            // Map flat inputs to structured vars
            config = {
                ...rest,
                vars: {
                    date: reservation_date,
                    time: reservation_time,
                    name: reservation_name,
                    number: reservation_number,
                    country_code: reservation_country_code,
                    no_of_people: reservation_pax,
                    business_id: reservation_business_id,
                    remark: reservation_remark
                },
                output_payload_var: output_payload_var || "reserv_data"
            };
        }

        return {
            id: node.id,
            type: node.type,
            config: config
        };
    });

    // Remap edges
    const finalEdges = [
        ...generatedEdges,
        ...edges.map(edge => {
            // Check if source needs redirection
            const newSource = sourceRedirections[edge.source] || edge.source;
            return {
                from_id: newSource,
                to_id: edge.target,
                condition: edge.data?.condition || { type: 'always' }
            };
        })
    ].filter(e => e.from_id !== startNode?.id); // Remove edges originating from actual start node placeholder

    // Find the real start node ID (target of the connection from 'start' node)
    let realStartNodeId = null;
    if (startNode) {
        const edgeFromStart = edges.find(e => e.source === startNode.id);
        if (edgeFromStart) {
            realStartNodeId = edgeFromStart.target;
        }
    }

    // Filter out the 'start' node type from final nodes list
    let finalNodesList = [...baseSerializedNodes, ...generatedNodes].filter(n => n.type !== 'start');

    // ---------------------------------------------------------
    // 3. Topological Sort (BFS) for Saving Order
    // ---------------------------------------------------------
    if (realStartNodeId) {
        const sortedMap = new Map(); // id -> node
        finalNodesList.forEach(n => sortedMap.set(n.id, n));

        const visited = new Set();
        const sortedNodes = [];
        const queue = [realStartNodeId];
        visited.add(realStartNodeId);

        while (queue.length > 0) {
            const currentId = queue.shift();
            const node = sortedMap.get(currentId);
            if (node) {
                sortedNodes.push(node);
                // Find neighbors
                const neighbors = finalEdges
                    .filter(e => e.from_id === currentId)
                    .map(e => e.to_id);

                neighbors.forEach(nid => {
                    if (!visited.has(nid)) {
                        visited.add(nid);
                        queue.push(nid);
                    }
                });
            }
        }

        // Add any disconnected nodes that weren't visited
        finalNodesList.forEach(n => {
            if (!visited.has(n.id)) {
                sortedNodes.push(n);
            }
        });

        finalNodesList = sortedNodes;
    }


    return {
        name,
        is_active,
        triggers: triggers.map(t => ({
            ...t,
            source: t.source || 'any'
        })),
        start_node_id: realStartNodeId,
        nodes: finalNodesList,
        edges: finalEdges
    };
};
